import React from 'react'

import { ZariContext } from '_zari/context'

import { Table, Modal, Col, Row, Button } from '_zari/core'

import * as SocioService from 'services/socio.service'

import NuevaPlacaSubForm from './subForms/nuevo'

const CrudPlacasModal = ({ handleClose, show, _idSocio, refrescarListaPlacasHandler }) => {
  const __zariContext = React.useContext(ZariContext)

  const [placas, setPlacas] = React.useState([])

  const refrescarTabla = React.useCallback(() => {
    SocioService.obtenerPlacasxIdSocio(_idSocio)
      .then(({ data }) => {
        setPlacas(data)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, _idSocio])

  React.useEffect(() => {
    refrescarTabla()
  }, [refrescarTabla])

  const clickEliminar = React.useCallback(
    idPlaca => {
      SocioService.eliminarPlacaxIdSocioxIdPlaca(_idSocio, idPlaca)
        .then(({ data }) => {
          __zariContext.snack('success', 'Registro eliminado.')
          refrescarTabla()
          refrescarListaPlacasHandler()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext, _idSocio, refrescarTabla, refrescarListaPlacasHandler]
  )

  return (
    <Modal show={show} size='lg'>
      <Modal.Header>
        <Modal.Title>PLACAS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <Table
              maxRowsShown={5}
              headRows={[{ label: 'PLACA' }, { label: '' }]}
              filas={placas}
              rowTemplate={row => (
                <Table.Row hover key={row._id}>
                  <Table.Cell>{row.placa || '--'}</Table.Cell>
                  <Table.Cell>
                    <Button tiny color='danger' outline onClick={() => clickEliminar(row._id)}>
                      Eliminar
                    </Button>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Col>
          <Col md={6} style={{ borderLeft: '1px solid black' }}>
            <NuevaPlacaSubForm idSocio={_idSocio} refrescarTabla={refrescarTabla} refrescarListaPlacasHandler={refrescarListaPlacasHandler} />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CrudPlacasModal
